export const FIRST_NAME_ID = 'first-name-field';
export const LAST_NAME_ID = 'last-name-field';
export const PHONE_ID = 'phone-field';
export const EMAIL_ID = 'email-field';
export const YEAR_ID = 'year-field';
export const MONTH_ID = 'month-field';
export const DAY_ID = 'day-field';
export const BIRTHDAY_ID = 'birthDate';
export const PERSISTED_LOGIN_ID = 'persisted-login-id';
